// Ligações entre notas: [[Título]] resolve para a nota com esse título (sem diferença de maiúsculas nem de acentos;
// título repetido = a mais antiga, como o servidor em src/domain/links.ts).
import { normalizeTag } from "../../../../shared/normalize.ts";
import type { Card } from "../../../../shared/types.ts";
import { store } from "../state.ts";

/** Privado (§4.2) fica fora do [[, das ligações e do clique, a não ser vindo de outro card privado. */
export const reachable = (c: Card, from?: string) => !c.isPrivate || !!(from && store.get(from)?.isPrivate);

export function noteByTitle(title: string, except?: string): Card | undefined {
  const key = normalizeTag(title);
  let best: Card | undefined;
  for (const c of store.cards.value) {
    if (c.kind === "note" && c.title && c.id !== except && normalizeTag(c.title) === key && (!best || c.createdAt < best.createdAt)) best = c;
  }
  return best && reachable(best, except) ? best : undefined;
}

/** Notas com título para o [[ : começo do título primeiro, depois as mais recentes (ordem da grade). */
export function titledNotes(query: string, except?: string, max = 8): Card[] {
  const q = normalizeTag(query);
  const hits = store.cards.value.filter((c) => c.kind === "note" && c.title?.trim() && c.id !== except && reachable(c, except) && normalizeTag(c.title).includes(q));
  const starts = (c: Card) => (normalizeTag(c.title!).startsWith(q) ? 0 : 1);
  return hits.sort((a, b) => starts(a) - starts(b)).slice(0, max);
}
